import React from 'react'

const Concept = () => {
    return (
        <div className='container'>
            <h1>Conepts of Coding </h1>
            <div className='containers'>
                In this section we learn about some important concepts of coding <br />
            </div>
            <ol>
                <li> Initialize a variable</li>
                When ww initalize a variable it means that we create a empty bucket in the computer to store our data <br />
                 <h3>How to initialize a variable </h3>
                 * always mention the data type of variable like: int,bool,float <br />
                 * then give a name to it remember that never give any reserved keyword to it <br />
                 * after giving a name just give the value to it.
                 <b>Example</b> <br />
                   int a = 10; <br />
                   if you want to update the variable just mention the variable name and its updated value <br />
                   <b>Example</b> <br />
                   a=30;
                   <li>Negataive numbers are stored in two's complement</li>
                   <h3>Method of two's complement</h3>
                      1) first change value to one's complement (change value 1-&gt;0 and 0 -&gt;1) <br />
                      2) Then, add 1 to it
                      <b>Example</b> <br />
                      We write 5 in Binary = 0101  <br />
                      <code>Here 0 in front represent that it is positive number</code>
                      Now, according to our first step change is value <br />
                      that will be 1010 <br />
                      now add 1 to it,it will becomes  1011<br />
                      1 in front of this represent that it is a negative number<br />
                      <li><h3>Addition of Data types</h3></li>
                      float + any type = float <br />
                      int + int/char = int <br />
                      char + char/int = int <br />
                      <li> <h3>Basic operators</h3></li>
                      <b>Unary</b> = [+,-] <br />
                      <b>Brackets</b> = [ () ] <br />
                      <b>Arithmetic</b> = [ + , - ,* ,/] <br />
                      <b>Assignment</b> = [ = ] <br />
                      <b>Relational</b> = [ &&-&gt;and || -&gt;or !-&gt;not] <br />
                      <li><h3>Modifiers</h3></li>
                      <b>Note</b> -&gt; to explain better we took the reference of int data type <br />
                      <b>long</b> -&gt; Increase the int size  by 8byte <br />
                      <b>short</b> -&gt; Deccrease the int size  by 2 byte <br />
                      <b>signed </b>-&gt; Allow both negative and positive numbers to store <br />
                      <b>unsigned</b> -&gt; Allow only positive to number to store 
                     <li>Difference between the type of Assignment and Initalization</li>
                     <table style={{marginBottom:50}}>
  <thead>
    <tr>
      <th scope="col">Assignment</th>
      <th scope="col">Initalization</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td data-label="Assignment">int a</td>
      <td data-label="Initalization"> Only declare not giving any value to it</td>
    </tr>
    <tr>
      <td scope="row" data-label="Assignment">int sum=0</td>
      <td data-label="Initalization">Only declare not giving any value to it</td>
    </tr>
    <tr>
      <td scope="row" data-label="Assignment">Compiler can give any garbage value</td>
      <td data-label="Initalization">Compiler give only assigne value</td>

    </tr>
    <tr>
      <td scope="row" data-label="Assignment">In this case no bucket will form</td>
      <td data-label="Initalization">In this case new bucket will form</td>

   </tr>
  
   
  </tbody>
</table>
<li>There are two types of Conversions</li>
  1)Implicit = An implicit conversion, also called view, is a conversion that is applied by the compiler in several situations<br />
  1) Explicit =This type of casting also involves a cast operator. The process is usually associated with information loss or failure to convert between types. <br />
                   </ol>
        </div>
    )
}

export default Concept
